import React from "react";
import InnerHTML from "dangerously-set-html-content";

const RichTextSection = ({ fields }) => {
  return (
    <InnerHTML className="rich-text-container" html={fields?.content?.value} />
  );
};

export default RichTextSection;
